import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

// orderForm.module.scss 를 panda css로 변환
export const labelWrapper = css({
  w: '100%',
  p: '16px 0 8px',
});

export const label = css({
  textStyle: 'Text/L/Strong',
  color: 'inverse.white',
});

export const subInfo = css({
  textStyle: 'Text/S/Regular',
});

export const actions = css({
  py: 8,
});

export const row = flex({
  gap: 6,
});

export const col = css({
  flex: 1,
  w: '50%',
  maxW: 161,
  wordBreak: 'break-word',
  color: 'content.default.level-2',
});

export const priceCol = css({
  textAlign: 'right',
});

export const price = css({
  mr: 4,
  color: 'inverse.white',
});

// FIXME: 추후 important 제거
export const formItem = css({
  w: '100%',
  pt: '0px!',
  pb: '16px!',
});
